module.exports = __webpack_public_path__ + "static/media/lakhdeepHS.f9307def.jpeg";